import DataExportDataSetDropdownBase from './DataExportDataSetDropdownBase'

export default function AuditTrailDataTypeDropdown({value, onChange}){
    const options = ['Data Change Log', 'User Activity Log'];

    return(
        <DataExportDataSetDropdownBase options={options} value={value} onChange={onChange} />
    );
}